import {useTranslation, withTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import _ from "lodash";
import {Col, Row} from "antd";
import {v1 as uuidv1} from "uuid";
import {Pie, measureTextWidth} from "@ant-design/plots";
function DatosTek(props) {
  const [datas, setDatas] = useState(null);

  useEffect(() => {
    let mQuestions = [];

    if (props.data) {
      mQuestions = props.data.filter(
        (it) => (it.questionType === "SINGLE" || it.questionType === "SUBJECT") && !it.question.includes("recibir inf")
      );

      let mAgrupado = _.groupBy(mQuestions, "assessment_id");

      setDatas(mAgrupado);
    }
  }, [props]);

  const createData = (key, groupby) => {
    let mRet = [];

    let mAgrupado = _.groupBy(datas[key], groupby);

    Object.keys(mAgrupado).map((key) => {
      let mKey = key;
      mRet.push({
        value: mAgrupado[key].length,
        type: mKey,
      });
    });

    return mRet;
  };

  function renderStatistic(containerWidth, text, style) {
    const {width: textWidth, height: textHeight} = measureTextWidth(text, style);
    const R = containerWidth / 2;

    let scale = 1;

    if (containerWidth < textWidth) {
      scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : "inherit"};">${text}</div>`;
  }

  const createConfig = (data) => {
    return {
      appendPadding: 10,
      data,
      angleField: "value",
      colorField: "type",
      radius: 0.9,
      /*legend: false,*/
      legend: {
        position: "bottom",
        flipPage: false,
        maxHeightRatio: 1,
        maxItemWidth: 1200,
      },
      innerRadius: 0.4,
      label: {
        text: "value",
        style: {
          fontWeight: "bold",
        },
      },
    };
  };

  return (
    <>
      {datas && (
        <Row key={uuidv1()} style={{marginTop: 10}}>
          {Object.keys(datas).map((key, i) => {
            return (
              <Col
                className={`colPrint ${(i + 1) % 4 === 0 ? "breakpage" : ""}`}
                id={"name" + key}
                id={"d" + key}
                span={24}
                key={uuidv1()}
              >
                <h5 style={{marginTop: 12}}>{datas[key][0].question}</h5>
                {datas[key][0].questionType === "SINGLE" && (
                  <Pie {...createConfig(createData(key, "response_student"))}></Pie>
                )}
                {datas[key][0].questionType === "SUBJECT" && (
                  <Pie {...createConfig(createData(key, "subjectStudent"))}></Pie>
                )}
              </Col>
            );
          })}
        </Row>
      )}
    </>
  );
}

export default withTranslation()(DatosTek);
